// Tryb — identity verification.

import { Card, InkCard, Overline } from "../../components/Card.jsx";
import { FieldCell } from "../../components/TrybField.jsx";
import { KycPanels } from "../Onboarding.jsx";
import { useStudio } from "../../lib/studioContext.js";
import { useFieldViews } from "../../lib/useFieldViews.js";

export default function Verification() {
  const { verifyStatus } = useStudio();
  const { fieldViews } = useFieldViews();

  const fields = verifyStatus === "Verified" ? [] : fieldViews(["K.01", "A1.07", "A1.11"], false);

  return (
    <div style={{ maxWidth: 820, display: "flex", flexDirection: "column", gap: 20 }}>
      {verifyStatus !== "Verified" && (
        <InkCard padding="28px 32px">
          <Overline color="inherit" style={{ opacity: 0.65 }}>
            One thing before you publish
          </Overline>
          <div
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "var(--text-2xl)",
              fontWeight: 800,
              letterSpacing: "var(--tracking-tight)",
              marginTop: 6,
              lineHeight: 1.1,
            }}
          >
            We need to know you’re you.
          </div>
          <div style={{ fontSize: "var(--text-sm)", opacity: 0.8, marginTop: 8, lineHeight: 1.55, maxWidth: 560 }}>
            Every facilitator on tryb is identity-checked before their first tryb goes live. It’s what lets a stranger book a seat at your table
            without a second thought. Draft yours now; publishing unlocks when this clears.
          </div>
        </InkCard>
      )}

      <Card padding={28}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "22px 20px" }}>
          <KycPanels />
          {fields.map((f) => (
            <FieldCell key={f.id} f={f} />
          ))}
        </div>
      </Card>
    </div>
  );
}
